(function ($) {
    $(".slider-items").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            fade: true,
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.slider').find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            }, ]
        });
    })

    $(".slider-for").each(function () {
        var thisElement = $(this);
        thisElement.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-nav'
        });
    })

    $(".slider-nav").each(function () {
        var thisElement = $(this);
        console.log(thisElement);
        thisElement.slick({
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.slider-for',
            dots: false,
            arrows: true,
            focusOnSelect: true,
            prevArrow: thisElement.parents('.slider-nav-wrap').find('.sliderPrevButton'),
            nextArrow: thisElement.parents('.slider-nav-wrap').find('.sliderNextButton'),
            variableWidth: true,
        });
    })

    $('.imagemodal').magnificPopup({
        type: 'image',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        gallery: {
            enabled: true,
            titleSrc: 'title',
            navigateByImgClick: true,
            preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        }
    });

    $(".videoblock").each(function () {
        var thisBlock = $(this);
        var altVideoSrc = $(this).data('mfp-src');
        if (altVideoSrc.includes('https://youtu.be')) {
            var newStr = altVideoSrc.split('https://youtu.be/')[1];
            var newYoutubeUrl = 'https://www.youtube.com/watch?v=' + newStr;
            $(this).attr('data-mfp-src', newYoutubeUrl);
        }
        $(this).magnificPopup({
            type: "iframe",
            removalDelay: 160,
            preloader: !1,
            fixedContentPos: !1
        })
    });
})(jQuery);